import React, { useState, useContext, useEffect } from "react";
import "./img_and_css/style.css";
import "./img_and_css/default.css";
import "./img_and_css/plugins/bootstrap.min.css";
import "./img_and_css/plugins/fontawesome.min.css";
import "./img_and_css/plugins/slick.css";
import "./img_and_css/plugins/animate.css";
import "./img_and_css/plugins/swiper.min.css";
import "./img_and_css/plugins/odometer.css";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../SessionManagement/AuthContext";
import { Link as RouterLink } from "react-router-dom";
import { xorDecrypt } from "../encrypt";
import $ from "jquery";

const NavbarHome = () => {
  const { state, dispatch } = useContext(AuthContext);
  const { isAuthenticated } = state;
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [contactAnchorEl, setContactAnchorEl] = useState(null); // Added state for contact submenu
  const [adminAnchorEl, setAdminAnchorEl] = useState(null);

  // Admin logic
  const [isAdmin, setIsAdmin] = useState(false); // State to track if the user is an admin

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    handleClose();
    localStorage.clear();
    navigate("/login");
  };
  const encryptedUsername = localStorage.getItem("username");
  const decryptedUsername = encryptedUsername
    ? xorDecrypt(encryptedUsername)
    : "";

  const avatarLetter = decryptedUsername
    ? decryptedUsername.charAt(0).toUpperCase()
    : "";

  // Handle opening the contact submenu
  const handleContactMenu = (event) => {
    setContactAnchorEl(event.currentTarget);
  };

  // Handle closing the contact submenu
  const handleContactClose = () => {
    setContactAnchorEl(null);
  };

  // Function to handle opening the Admin submenu
  const handleAdminMenu = (event) => {
    setAdminAnchorEl(event.currentTarget);
  };

  // Function to handle closing the Admin submenu
  const handleAdminClose = () => {
    setAdminAnchorEl(null);
  };

  useEffect(() => {
    const checkAdminStatus = () => {
      const userRole = xorDecrypt(localStorage.getItem("userRole"));
      if (userRole === "admin") {
        setIsAdmin(true);
      }
    };
    checkAdminStatus();

    // Initialize jQuery functions
    const mainNav = () => {
      $(".cs_nav").append('<span class="cs-munu_toggle"><span></span></span>');
      $(".menu-item-has-children").append(
        '<span class="cs-munu_dropdown_toggle"></span>'
      );
      $(".cs-munu_toggle").on("click", function () {
        $(this)
          .toggleClass("cs-toggle_active")
          .siblings(".cs_nav_list")
          .slideToggle();
      });
      $(".cs-munu_dropdown_toggle").on("click", function () {
        $(this).toggleClass("active").siblings("ul").slideToggle();
        $(this).parent().toggleClass("active");
      });
      // Search Toggle
      $(".cs_header_search_btn").on("click", function () {
        $(this).parents(".cs_header_search_wrap").toggleClass("active");
      });
    };

    mainNav();
  }, []);

  const decryptedEnrollmentStatus = xorDecrypt(
    localStorage.getItem("enrollmentStatus")
  );
  //console.log("decryptedEnrollmentStatus", decryptedEnrollmentStatus);

  const handleHomeClick = () => {
    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 100); // Delay to ensure navigation happens first
  };

  return (
    <header className="cs_site_header cs_style_1 cs_sticky_header cs_site_header_full_width">
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <a className="cs_site_branding" onClick={handleHomeClick}>
                <img src="../assets/img/logo.png" alt="InSight ABA Notes" />
              </a>
              <div className="cs_nav cs_primary_font fw-medium">
                <ul className="cs_nav_list fw-medium text-uppercase">
                  <li>
                    <a
                      href="#"
                      className="link-no-decoration-1"
                      onClick={handleHomeClick}
                    >
                      Home
                    </a>
                  </li>
                  <li className="menu-item-has-children">
                    <a href="#" className="link-no-decoration-1">
                      Know More
                    </a>
                    <ul>
                      <li>
                        <Link to="/services" className="link-no-decoration-1">
                          Services
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/demographics"
                          className="link-no-decoration-1"
                        >
                          Demo
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/subscription" className="link-no-decoration-1">
                      Pricing{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us" className="link-no-decoration-1">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/faqs" className="link-no-decoration-1">
                      FAQ
                    </Link>
                  </li>

                  <li>
                    <Link to="/contact" className="link-no-decoration-1">
                      Contact
                    </Link>
                  </li>
                  {isAdmin && (
                    <li className="menu-item-has-children">
                      <a href="#" className="link-no-decoration-1">
                        Admin
                      </a>
                      <ul>
                        <li>
                          <Link
                            to="/manageSubscriber"
                            className="link-no-decoration-1"
                          >
                            Subscriber
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/subscriberClient"
                            className="link-no-decoration-1"
                          >
                            Client
                          </Link>
                        </li>
                        <li>
                          <Link to="/allEmail" className="link-no-decoration-1">
                            All Contact Us
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/invoiceAdmin"
                            className="link-no-decoration-1"
                          >
                            Invoice
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/supportPage"
                            className="link-no-decoration-1"
                          >
                            All Support
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/feedbackPage"
                            className="link-no-decoration-1"
                          >
                            All Feedback
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="cs_main_header_right">
              <div className="cs_toolbox">
                <div className="cs_header_contact">
                  <div className="cs_header_contact_right">
                    {isAuthenticated ? (
                      <>
                        <Avatar onClick={handleMenu} sx={{ cursor: "pointer" }}>
                          {avatarLetter}
                        </Avatar>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          sx={{ marginLeft: "-30px" }}
                        >
                          {decryptedEnrollmentStatus === "true" && (
                            <MenuItem
                              onClick={() => {
                                navigate("/dashtemp");
                                handleClose();
                              }}
                            >
                              Dashboard
                            </MenuItem>
                          )}

                          <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                      </>
                    ) : (
                      <>
                        <Button
                          className="cs_btn cs_style_1 cs_fs_16 cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_10 cs_pb_10 overflow-hidden"
                          color="inherit"
                          component={RouterLink}
                          to="/register"
                          style={{ marginRight: "20px" }}
                        >
                          Register
                        </Button>
                        <Button
                          className="cs_btn cs_style_1 cs_fs_16 cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_10 cs_pb_10 overflow-hidden"
                          color="inherit"
                          component={RouterLink}
                          to="/login"
                        >
                          Login
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavbarHome;
